export default "__VITE_ASSET__CYlnmFyn__"